import { createSlice } from "@reduxjs/toolkit";

const initialUserState = {
    token: null,
    user: null,
    allUsers: null,
    userLocations: null
}

const userSlice = createSlice({
    name: 'user',
    initialState: initialUserState,
    reducers: {
        setToken(state, data) {
            state.token = data.payload
        },
        setUser(state, data) {
            state.user = data.payload
        },
        setAllUsers(state, data) {
            state.allUsers = data.payload
        },
        setUserLocations(state, data) {
            state.userLocations = data.payload
        },
    }
})

export const userActions = userSlice.actions

export default userSlice.reducer